import { Field, useFormikContext } from "formik";
import { DayRangePickerCamvio } from "components";
import { useFormInputHelpers } from "./useFormInputHelpers";
import { useCallback } from "react";

const FormDateRangeInput = ({
  name,
  onChange,
  shouldHaveErrorBehaviorAfterSubmit,
  className,
  ...props
}) => {
  const { setFieldValue, setFieldTouched } = useFormikContext();
  const { shouldDisplayError, finalHelperText } = useFormInputHelpers({
    name,
    shouldHaveErrorBehaviorAfterSubmit,
  });

  const handleChange = useCallback(
    (newValue) => {
      if (typeof onChange === "function") {
        onChange(newValue);
        return;
      }

      const { from, to } = newValue || {};
      setFieldValue(`${name}.from`, from).then(() => {
        setFieldTouched(`${name}.from`, true);
      });
      setFieldValue(`${name}.to`, to).then(() => {
        setFieldTouched(`${name}.to`, true);
      });
    },
    [name, onChange, setFieldTouched, setFieldValue],
  );

  const helperText = finalHelperText
    ? (finalHelperText?.from ?? finalHelperText.to)
    : "";
  return (
    <Field
      name={name}
      as={DayRangePickerCamvio}
      formatDisplay="D MMM YYYY"
      isError={shouldDisplayError}
      helperText={helperText}
      className={className}
      onChange={handleChange}
      {...props}
    />
  );
};

export default FormDateRangeInput;
